import { Copy } from 'lucide-react';
import { toast } from '@sara/ui/components/sonner';
import { PLATFORM_VARIABLES } from '../../lib/platform-variables';

/** Copies a {{token}} for the given variable key and confirms via toast. */
export function copyVariableToken(key: string) {
  void navigator.clipboard?.writeText(`{{${key}}}`).catch(() => {});
  toast.success(`Copied {{${key}}}`);
}

/**
 * The platform-provided variables — a "Provided by the platform" label and one
 * read-only row per built-in (name · copyable {{token}} chip · where the value
 * comes from). Shared by the version form and the template detail view so the
 * built-ins look identical wherever variables are shown.
 */
export function PlatformVariablesList() {
  return (
    <div className="space-y-3">
      <p className="text-[12px] font-medium text-foreground/80">Provided by the platform</p>
      <ul
        className="divide-y divide-border/40 rounded-lg border border-dashed"
        data-testid="platform-variables"
      >
        {PLATFORM_VARIABLES.map((v) => (
          <li key={v.key} className="flex items-center gap-3 px-4 py-2">
            <span className="min-w-0 shrink-0 truncate text-sm text-foreground/80">{v.name}</span>
            <button
              type="button"
              onClick={() => copyVariableToken(v.key)}
              title="Copy token"
              className="inline-flex items-center gap-1 rounded-md bg-primary/10 px-2 py-0.5 font-mono text-xs text-primary transition-colors hover:bg-primary/20"
            >
              {`{{${v.key}}}`}
              <Copy className="h-3 w-3 opacity-60" />
            </button>
            <span className="ml-auto truncate text-xs text-muted-foreground">{v.detail}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
